import { render, staticRenderFns } from "./login-window-footer.vue?vue&type=template&id=187b70c6&scoped=true"
import script from "./login-window-footer.vue?vue&type=script&lang=js"
export * from "./login-window-footer.vue?vue&type=script&lang=js"
import style0 from "./login-window-footer.vue?vue&type=style&index=0&id=187b70c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b70c6",
  null
  
)

export default component.exports